<!-- 绑定第三方账号	!-->
<template>
	<div class='page greyBg'>
		<pageTitle title='完善个人信息' />
		<div class='userMsg'>
			<img :src='oauth.headUrl'/>
			<div>
				{{oauth.nickName}}
			</div>
		</div>
		<div class='whiteBg main'>
			<mu-text-field v-if='needRegist' @blur='nameChange' :errorText="nameErr" v-model='name' label="姓名" labelFloat :fullWidth='true'/>
			<mu-text-field v-if='!needRegist' @blur='userNameChange' :errorText="usernameErr" v-model='username' label="卡号/手机号/邮箱" labelFloat :fullWidth='true'/>
			<mu-text-field v-if='needRegist' @blur='phoneChange' :errorText="phoneErr" v-model='phone' label="手机号" labelFloat :fullWidth='true'/>
			<mu-text-field v-if='needRegist' @blur='idnoChange' :errorText="idnoErr" v-model='idno' label="身份证号" labelFloat :fullWidth='true'/>
			<mu-text-field type='password' v-model='password' @blur='passwordChange' :errorText="passwordErr" label="密码" labelFloat :fullWidth='true'/>
			<mu-text-field type='password' v-if='needRegist' @blur='rePasswordChange' :errorText="rePasswordErr" v-model='rePassword' label="确认密码" labelFloat :fullWidth='true'/>
			<div class='relative'>
				<mu-text-field v-model='imgCode' @blur='imgCodeChange' :errorText="imgCodeErr" label="图片验证码" labelFloat :fullWidth='true'/>
				<img v-bind:src="this.TPFJM" style="width:27% ; margin-left:2% ; margin-bottom:-2%" v-on:click="this.getValidateCode"   />
			</div>
			<div  v-if='needRegist' class='relative'>
				<mu-text-field v-model='phoneCode' @blur='phoneCodeChange' :errorText="phoneCodeErr" label="手机验证码" labelFloat :fullWidth='true'/>
				<div class='right'>
					<mu-raised-button @click='sendSMS'  v-bind:style="{ height:'30px'}"  label="获取验证码"  primary/>
				</div>
			</div>
			<mu-raised-button @click='doBind' class='btn' :label="btnMsg" v-bind:style="{ height:'50px'}" :fullWidth='true' primary/>
			<div @click='changeBindType' class='bintHint'>{{changeMsg}}</div>
		</div>
		<mu-toast v-if="toast" v-bind:message="hintMsg" @close="hideToast" id="alertline" />
		<!--弹出框 选择是否-->
    <pop :display='popDisplay' @closeHandler='closePop' @okHandler='closePop' title='提示' :msg='popMsg' :onlyOk='popOnlyOk'/> 
	</div>
</template>

<style lang="less" scoped>
	.page{
		padding-bottom:56px;
	}
	.userMsg{
		margin:0.6rem;
		text-align:center;
		font-size:0.28rem;
		color:#666666;
		img{
			width:1.6rem;
			height:1.6rem;
			margin-bottom:0.1rem;
		}
	}
	.main{
		margin:0.2rem;
		padding:0.1rem 0.3rem 0.4rem 0.3rem;
		.btn{
			margin:0.2rem 0;
		}
		.bintHint{
			text-align:center;
			text-decoration:underline;
		}
	}
	.relative{
		position:relative;
		img{
			position:absolute;
			top:33px;
			right:0;
		}
		.right{
			position:absolute;
			top:27px;
			right:0;
		}
	}
</style>

<script>
	import pageTitle  from '../../components/pageTitle.vue'
	import api from '../../api/index.js'
	import valid from '../../utils/valid.js'
	import { mapMutations, mapGetters } from 'vuex'
	import pop from '../../components/pop'

	export default {
		data () {
			return{
				hintMes: '',
      	toast: false,
				TPFJM:'',
				oauth:{
					nickName:'用户昵称',
					headUrl:'../../../static/LoadingBest.gif'
				},
				name:'',
				nameErr:'',
				username:'',
				usernameErr:'',
				phone:'',
				phoneErr:'',
				idno:'',
				idnoErr:'',
				imgCode:'',
				imgCodeErr:'',
				password:'',
				passwordErr:'',
				rePassword:'',
				rePasswordErr:'',
				phoneCode:'',
				phoneCodeErr:'',
				//提示信息
        hintMsg:'',
        //提示框显示状态
        toast: false,
				//需要注册
				needRegist:true,
				btnMsg:'立即开通',
				changeMsg:'已有会员账号？',
				//pop弹出框
				popDisplay: false,
				popMsg:'',
				popOnlyOk:false,
			}
		},
		activated(){
			this.getAuthInfo()
			this.getValidateCode()
		},
		methods:{
			...mapMutations([
				'setG_UserInfo'
			]),
			showToast() {
				this.toast = true
				if (this.toastTimer) clearTimeout(this.toastTimer)
				this.toastTimer = setTimeout(() => { this.toast = false }, 2000)
			},
			hideToast() {
				this.toast = false
				if (this.toastTimer) clearTimeout(this.toastTimer)
			},
			getValidateCode() {
      	this.TPFJM = api.getValidateCode();
    	},
			//获取用户第三方信息
			getAuthInfo(){
				this.$http.post(api.getAuthInfo()).then((res) => {
					console.log(res)
					if(res.Result){
						this.oauth = res.Data
					}	
					else{
						this.openPop(res.Message,true)
						//this.showToast(res.Message)
					}
				})
			},
			//发送短信验证码
			sendSMS(){
				if(this.name.trim() == '' || this.nameErr != ''){
					this.showToast('请检查您的姓名是否填写正确！')
					return
				}
				if(this.phone.trim() == '' || this.phoneErr != ''){
					this.showToast('请检查您的手机号是否填写正确！')
					return
				}
				if(this.idno.trim() == '' || this.idnoErr != ''){
					this.showToast('请检查您的身份证号是否填写正确！')
					return
				}
				if(this.imgCode.trim() == '' || this.imgCodeErr != ''){
					this.showToast('请检查您的图片验证码是否填写！')
					return
				}
			  var params = new this.URLSearchParam()
				params.append('phone', this.phone.trim())
				params.append('name', this.name.trim())
				params.append('idno', this.idno.trim())
				params.append('imgCode', this.imgCode.trim())
				this.$http.post(api.SendSMS(), params.toParam()).then((res) => {
					//刷新验证码
					this.getValidateCode()
					this.showToast(res.Message)
				})
			},
			//注册和绑定
			registAndBind(){
			  var params = new this.URLSearchParam()
				params.append('phone', this.phone.trim())
				params.append('name', this.name.trim())
				params.append('idno', this.idno.trim())
				params.append('password', this.password.trim())
				params.append('validCode', this.phoneCode.trim())
				this.$http.post(api.RegistAndBind(), params.toParam()).then((res) => {
					this.getValidateCode()
					if(res.Result){
						var that = this
						this.showToast('绑定成功！')
						this.saveUserInfo(res.Data)
						setTimeout(function(){
							that.$router.push({ path: '/user/UserCenter' })
						},1200)
					}
					else{
						this.openPop(res.Message,true)
					}
				})
			},
			//已注册用户绑定
			bind(){
			  var params = new this.URLSearchParam()
				params.append('username', this.username.trim())
				params.append('password', this.password.trim())
				params.append('imgCode', this.imgCode.trim())
				this.$http.post(api.Bind(), params.toParam()).then((res) => {
					this.getValidateCode()
					if(res.Result){
						this.showToast('绑定成功！')
						var that = this
						that.saveUserInfo(res.Data)
						setTimeout(function(){
							that.$router.push({ path: '/user/UserCenter' })
						},1200)
					}
					else{
						this.openPop(res.Message,true)
					}
				})
			},
			doBind(){
				if(this.needRegist){
					//验证输入
					if(this.name.trim() == '' || this.nameErr != ''){
						this.showToast('请检查您的姓名是否填写正确！')
						return
					}
					if(this.phone.trim() == '' || this.phoneErr != ''){
						this.showToast('请检查您的手机号是否填写正确！')
						return
					}
					if(this.idno.trim() == '' || this.idnoErr != ''){
						this.showToast('请检查您的身份证号是否填写正确！')
						return
					}
					if(this.password.trim() == '' || this.passwordErr != ''){
						this.showToast('请检查您的密码是否填写正确！')
						return
					}
					if(this.phoneCode.trim() == '' || this.phoneCodeErr != ''){
						this.showToast('请检查您的手机验证码是否填写正确！')
						return
					}
					this.registAndBind()
				}
				else{
					//验证输入
					if(this.username.trim() == '' || this.usernameErr != ''){
						this.showToast('请检查您的用户名是否填写正确！')
						return
					}
					if(this.password.trim() == '' || this.passwordErr != ''){
						this.showToast('请检查您的密码是否填写正确！')
						return
					}
					if(this.imgCode.trim() == '' || this.imgCodeErr != ''){
						this.showToast('请检查您的图片验证码否填写正确！')
						return
					}
					this.bind()
				}
			},
			changeBindType(){
				if(this.needRegist){
					this.btnMsg = '立即绑定'
					this.changeMsg = '没有会员账号？'
				}
				else{
					this.btnMsg = '立即开通'
					this.changeMsg = '已有会员账号？'
				}
				this.imgCode = ''
				this.password = ''
				this.getValidateCode()
				this.needRegist = !this.needRegist
			},
			nameChange(){
				if(this.name.trim() == ''){
					this.nameErr = '姓名是必填项 *'
				}
				else{
					this.nameErr = ''
				}
			},
			userNameChange(){
				if(this.username.trim() == ''){
					this.usernameErr = '用户名是必填项 *'
				}
				else{
					this.usernameErr = ''
				}
			},
			phoneChange(){
				if(this.phone.trim() == ''){
					this.phoneErr = '手机号是必填项 *'
				}
				else if(!this.phone.isPhone()){
					this.phoneErr = '请填写正确的手机号'
				}
				else{
					this.phoneErr = ''
				}
			},
			idnoChange(){
				if(this.idno.trim() == ''){
					this.idnoErr = '身份证号是必填项 *'
				}
				else{
					this.idnoErr = ''
				}
			},
			passwordChange(){
				if(this.password.trim() == ''){
					this.passwordErr = '密码是必填项 *'
				}
				else{
					this.passwordErr = ''
				}
			},
			rePasswordChange(){
				if(this.rePassword.trim() == ''){
					this.rePasswordErr = '请填写确认密码 *'
				}
				else if(this.rePassword.trim() != this.password){
					this.rePasswordErr = '两次密码不一致'
				}
				else{
					this.rePasswordErr = ''
				}
			},
			imgCodeChange(){
				if(this.imgCode.trim() == ''){
					this.imgCodeErr = '请填写图片验证码 *'
				}
				else{
					this.imgCodeErr = ''
				}
			},
			phoneCodeChange(){
				if(this.phoneCode.trim() == ''){
					this.phoneCodeErr = '请填写手机验证码 *'
				}
				else{
					this.phoneCodeErr = ''
				}
			},
			saveUserInfo(result) {// 保存登录信息
				// 保存登录信息
				var UserInfo = this.g_UserInfo;
				if (result.Card_Kind_Diplay == '网上数字卡') {
					result.Card_Kind_Diplay = '数字卡';
				}
				UserInfo.OrderRefresh1 = true;
				UserInfo.OrderRefresh2 = true;
				UserInfo.OrderRefresh3 = true;
				UserInfo.Card_Kind_Diplay = result.Card_Kind_Diplay;
				UserInfo.Card_no = result.Card_no;
				UserInfo.Name = result.Name;
				UserInfo.Sex = result.Sex;
				UserInfo.sjno = result.sjno;
				UserInfo.Email = result.Email;
				UserInfo.Card_Money = result.Card_Money;
        UserInfo.StoredValueCard_Money = result.StoredValueCard_Money;
        UserInfo.HasOpenStoreCard = result.HasOpenStoreCard
				UserInfo.MallCoin = result.MallCoin;
				UserInfo.isSignInedToday = result.isSignInedToday;
				this.setG_UserInfo(UserInfo)
    	},
			//打开提示窗
      showToast(hintMsg) {
				if(hintMsg){
					this.hintMsg = hintMsg
				}
        this.toast = true
        if (this.toastTimer) clearTimeout(this.toastTimer)
          this.toastTimer = setTimeout(() => { this.toast = false }, 3000)
      },
      //隐藏提示窗
      hideToast() {
        this.toast = false
        if (this.toastTimer) clearTimeout(this.toastTimer)
			},
			closePop(){
				this.popDisplay = false
			},
			openPop(msg,onlyOk){
				//是否仅仅显示确定按钮
				if(onlyOk){
					this.popOnlyOk = onlyOk
				}
				else{
					this.popOnlyOk = false
				}
				if(msg){
					this.popMsg = msg
				}
				this.popDisplay = true
			}
		},
		components: {
			pageTitle,pop
		},
	  computed: {
			...mapGetters([
				'g_UserInfo', 'g_loginInfo'
			])
		},
	}
</script>


// WEBPACK FOOTER //
// bindAccount.vue?58351ee6